// A single short "ding" — like the bell on a hotel desk — played once when a render completes.
// Synthesized with the Web Audio API so there's no asset to load.
export function playBell() {
  try {
    if (typeof localStorage !== "undefined" && localStorage.getItem("sms_sound") === "off") return;
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const now = ctx.currentTime;
    // Two bell-like partials (fundamental + ~2.76x inharmonic overtone) with a fast attack and long decay.
    const partials = [
      { freq: 880, gain: 0.5 },
      { freq: 880 * 2.76, gain: 0.18 },
    ];
    partials.forEach(({ freq, gain }) => {
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      g.gain.setValueAtTime(0.0001, now);
      g.gain.exponentialRampToValueAtTime(gain, now + 0.005);
      g.gain.exponentialRampToValueAtTime(0.0001, now + 1.6);
      osc.connect(g);
      g.connect(ctx.destination);
      osc.start(now);
      osc.stop(now + 1.7);
    });
    setTimeout(() => { try { ctx.close(); } catch { /* noop */ } }, 2000);
  } catch {
    /* audio not available — silently skip */
  }
}
